import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { AlertComponent } from '../../objects/alert/alert/alert.component';
import { DatePipe } from '@angular/common';
import { Detajuste } from 'src/app/Models/ajuste/detajuste/detajuste';
import { ALertOption } from 'src/app/Models/alert/alert-option';
import { AlertType } from 'src/app/Models/alert/alert-type';
import { Articulo } from 'src/app/Models/articulo/articulo';
import { Filtro } from 'src/app/Models/filtro/filtro';
import { Moneda } from 'src/app/Models/moneda/moneda';
import { Motivo } from 'src/app/Models/motivo/motivo';
import { TipoOperacion } from 'src/app/Models/tipooperacion/tipo-operacion';
import { Usuario } from 'src/app/Models/usuario/usuario';
import { AuthService } from 'src/app/Service/auth.service';
import { DataService } from 'src/app/Service/data.service';
import { NotifyService } from 'src/app/Service/notify.service';
import { ComprasArticuloComponent } from '../../compras/compras-detcompra/compras-detcompra.component';
import { InfoComponent } from '../../objects/info/info/info.component';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { Ajuste } from 'src/app/Models/ajuste/ajuste';

@Component({
  selector: 'app-add-ajuste',
  templateUrl: './add-ajuste.component.html',
  styleUrls: ['./add-ajuste.component.css']
})
export class AddAjusteComponent implements OnInit {

  public funcion: Function;
  public isShow: boolean = false;
  public usuario: Usuario = new Usuario();
  public ajuste: Ajuste = new Ajuste();
  public tipos_opera: TipoOperacion[] = [];
  public detajustes: Detajuste[] = [];
  public motivos: Motivo[] = [];
  public detajuste: Detajuste = new Detajuste();
  public articulo: Articulo = new Articulo();
  public monedas: Moneda[] = [];
  public alertType: AlertType = new AlertType();
  public options: ALertOption = new ALertOption();
  public isadddetajuste: boolean = false;
  public index: number = 0;
  public numitem: number = 0;
  public pagarticulo: any;
  public isedit: Boolean = false;
  public filtroguia: Filtro = new Filtro()
  @ViewChild('btnshowFactura', null) btnshowFactura: ElementRef;
  @ViewChild('btnclose', null) btnclose: ElementRef;
  @ViewChild('artloading', null) artloading: LoadingComponent;
  @ViewChild('artinfo', null) artinfo: InfoComponent;
  @ViewChild(AlertComponent, null) alert: AlertComponent;
  @ViewChildren('icon0, icon1, icon2, icon3') icons: QueryList<ElementRef>;
  @ViewChild('btnshow', null) btnshowcompr: ElementRef;
  @ViewChild('listadetajuste', null) listadetajuste: ElementRef;
  @ViewChild(ComprasArticuloComponent, null) public frmcomprasdetalles: ComprasArticuloComponent;
  @ViewChild(LoadingComponent, null) loading: LoadingComponent;
  @ViewChild(InfoComponent, null) info: InfoComponent;
  @ViewChild('txtdireccion', null) txtdireccion: ElementRef;



  constructor(private data: DataService, private notify: NotifyService, private datepipe: DatePipe, private auth: AuthService) {
    this.usuario = this.auth.getCurrentUser();
  }

  ngOnInit() {

  }

  public show(affterfunction: Function = null) {

    this.funcion = affterfunction;
    this.isShow = true;

    setTimeout(async () => {
      this.btnshowFactura.nativeElement.click();
      this.artloading.show('Cargando datos');
      console.log(this.ajuste.fecha);
      //this.Enable()
      this.CalcularSumaTotal();
      this.GetTiposOperaciones();
      this.GetMotivos();
      this.getMonedas();
      if (this.isedit) {
        this.GetDetalles()
        this.ajuste.idsucursal = this.ajuste.idsucursal.idsucursal;
      }
      //this.PrepararData();
      this.artloading.hide();
    }, 10);
  }


  getMonedas() {
    this.data.GetSimple(this.data.api.moneda).subscribe(r => {
      console.log(r);
      this.monedas = r;
    })
  }

  getTipocambio() {
    this.data.GetTipoCambio(this.ajuste.fecha).then(r => {
      console.log(r);
      this.ajuste.tcambio = r.venta;
    })
  }

  GetTiposOperaciones() {
    this.data.GetSimple(this.data.api.tip_opetbl12).subscribe(r => {
      this.tipos_opera = r;
    }), (e => { console.log(e.eror.text) });
  }

  GetMotivos() {
    this.data.GetSimple(this.data.api.motivo).subscribe(r => {
      this.motivos = r;
    }), (e => { console.log(e.eror.text) });
  }


  GetDetalles() {
    let filtro = new Filtro()
    filtro.idajuste = this.ajuste.idajuste;
    this.data.Post('filtrardoc/Detajuste', filtro).subscribe(
      (r) => {
        console.log(r);
        
        r.data.forEach(det => {
          let newdetalle: Detajuste = new Detajuste()
          newdetalle.idajuste = this.ajuste.idajuste
          newdetalle.id_det = det.id_det
          newdetalle.item = this.detajustes.length + 1;
          newdetalle.cantidad = det.cantidad;
          newdetalle.total = det.total;
          newdetalle.texto = det.texto;
          newdetalle.articulo = det.idproduct;
          newdetalle.idproduct = det.idproduct.idproduct;
          newdetalle.valunit = det.idproduct.ultcosto;
          this.detajustes.push(newdetalle);
        });
        this.CalcularSumaTotal();
      },
      (error) => {
        console.log(error);
      }
    )
  }

  ShowNewDetcompra() {

    this.frmcomprasdetalles.articulo = null;
    this.frmcomprasdetalles.show(() => {
      let newdetalle: Detajuste = new Detajuste();

      //this.articulo = this.frmcomprasdetalles.articulo;
      if (this.frmcomprasdetalles.articulo != null) {
        newdetalle.item = this.detajustes.length + 1;
        newdetalle.articulo = this.frmcomprasdetalles.articulo;
        newdetalle.idproduct = this.frmcomprasdetalles.articulo.idproduct;
        newdetalle.valunit = this.frmcomprasdetalles.articulo.ultcosto?this.frmcomprasdetalles.articulo.ultcosto:0;
        this.detajustes.push(newdetalle);
      }
    });
  }

  UpdateDetCompra(index: number, field: string, value: string) {
    this.detajustes[index][field] = value;
    if (field === 'cantidad' || field === 'texto' || field === 'valunit') {
      this.PrepararAjuste(index);
    }
    this.CalcularSumaTotal();
  }

  async GuardarDetalle() {
    console.log(this.detajuste);
    if (this.detajuste.idproduct == undefined) {
      this.data.notify("Elemento vacio", "Error", this.alertType.warning);
    }
    else {
      this.detajuste.n = this.index
      this.index++
      this.detajustes.push(this.detajuste);
      this.CalcularSumaTotal();
      this.isadddetajuste = false
    }
    //this.guardarArticulo();
  }

  async CancelarDetalle() {
    this.isadddetajuste = false
  }

  ShowNewdetajuste() {

    this.frmcomprasdetalles.articulo = null;
    this.frmcomprasdetalles.show(() => {
      this.articulo = this.frmcomprasdetalles.articulo;

      if (this.articulo != null) {
        this.detajuste.articulo = this.articulo
        this.detajuste.idproduct = this.articulo.idproduct
        this.detajuste.valunit = this.articulo.ultcosto
      }
    });
  }

  CalcularTotal(item: Detajuste) {
    if (item.valunit != undefined && item.cantidad != undefined) {
      item.total = parseFloat((item.valunit * item.cantidad).toFixed(2))
    }
  }

  CalcularSumaTotal() {
    let sumatotal = 0;
    this.detajustes.forEach(detalle => {
      sumatotal += (+detalle.total);
    });
    this.ajuste.total = sumatotal
  }

  PrepararAjuste(index: number) {
    const item = this.detajustes[index];
    this.CalcularTotal(item);
    this.ajuste.idsucursal = this.data.getSucursalId();
    this.ajuste.estado = 'EMI';
    // const parsedDate = moment(this.ajuste.fecha, 'DD-MM-YYYY');
    // this.ajuste.fecha = parsedDate.format('YYYY-MM-DD');
  }

  async GuardarAjuste() {
    console.log(this.detajustes);

    await this.data.AsyncPost(this.data.api.ajuste, this.ajuste).then(r => {
      if (r.idajuste != null) {
        console.log("cabezera guardada");

        console.log(r);
        this.detajustes.forEach(detajuste => {

          detajuste.idajuste = r.idajuste
          this.data.AsyncPost(this.data.api.detajuste, detajuste).then(d => {

            console.log(d);
            if (d.length > 0) {
              console.log("detalle guardado");
              console.log(d);
            }
          }).catch(e => console.log(e))
        });
        this.data.notify("Elemento guardado", "Exito", this.alertType.success, this.options, () => { this.close() });

      } else {
        console.log("error");
        console.log(r);

      }
    }).catch(() => this.data.notify("Datos vacios o invalidos", "Error", this.alertType.warning, this.options, this.ajuste.fecha = null))

  }

  async ActualizarAjuste(idajuste:string) {
    console.log(this.detajustes);
    console.log(this.ajuste);
    
    console.log("Enviando Ajuste",this.ajuste);
    await this.data.AsyncPut(this.data.api.ajuste, idajuste, this.ajuste).then(r => {
      if (r.message != "error") {
        console.log("cabezera guardada");

        console.log(r);
        this.detajustes.forEach(detajuste => {
          if (detajuste.id_det != undefined) {
            // Actualizar detalle existente
            this.data.AsyncPut(this.data.api.detajuste, detajuste.id_det, detajuste).then(d => {
              console.log("Detalle actualizado", d);
            }).catch(e => console.log(e));
            
          }else{
            // Crear nuevo detalle
            detajuste.idajuste = r.data.idajuste;
            this.data.AsyncPost(this.data.api.detajuste, detajuste).then(d => {
              console.log("Detalle guardado", d);
            }).catch(e => console.log(e));
          } 
          
        });
        this.data.notify("Elemento guardado", "Exito", this.alertType.success, this.options, () => { this.close() });

      } else {
        console.log("error");
        console.log(r);

      }
    }).catch(() => this.data.notify("Datos vacios o invalidos", "Error", this.alertType.warning, this.options, this.ajuste.fecha = null))

  }

  refresh(): Function {
    this.ajuste = new Ajuste();
    this.detajustes = [];
    return null
  }

  Guardar() {
    if (this.ajuste.motivo && this.ajuste.referencia && this.ajuste.tipo_ope && this.ajuste.fecha  && this.detajustes.length > 0) {
      if (this.ajuste.total>0) {
        this.GuardarAjuste()  
      }else{
        this.data.notify("El total no puede ser menor o igual a 0","Atencion",this.data.alertType.info)
      }
      
    } else {
      this.data.notify("Faltan datos", "Atencion", this.data.alertType.info)
    }
  }

  Actualizar() {
    if (this.ajuste.motivo && this.ajuste.referencia && this.ajuste.tipo_ope && this.ajuste.fecha  && this.detajustes.length > 0) {
      if (this.ajuste.total>0) {
        this.ActualizarAjuste(this.ajuste.idajuste)  
      }else{
        this.data.notify("El total no puede ser menor o igual a 0","Atencion",this.data.alertType.info)
      }
      
    } else {
      this.data.notify("Faltan datos", "Atencion", this.data.alertType.info)
    }
  }


  async DeleteDetCompra(indice: number) {
    console.log(indice);
    this.detajustes.splice(indice, 1);
    this.CalcularSumaTotal();
  }

  close() {
    this.detajustes = [];
    this.btnclose.nativeElement.click();
    setTimeout(() => {
      this.isShow = false;
      this.isedit = true;
    }, 500);
    setTimeout(() => { if (this.funcion != null) { this.funcion(); } }, 10);
  }
}
